import React from 'react';
import ReactDOM from 'react-dom/client';
import { consumeAuthHandoff } from '@bill/ui';
import App from './App';

// Pick up tokens passed via URL by AppSwitcher (cross-origin handoff)
consumeAuthHandoff();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
